import React from 'react';
import { FlexBox, responsive } from '@vp/swan';

const ResponsiveFlexBox = responsive(FlexBox);

interface StepItemContainerProps {
    children: React.ReactNode;
    isModal: boolean;
    mdStepItemDirection?: 'row' | 'column';
}
export default function StepItemContainer({
    children,
    isModal,
    mdStepItemDirection = 'row',
}: StepItemContainerProps) {
    return (
        <ResponsiveFlexBox
            marginBottom={isModal ? 1 : 3}
            flexDirection="row"
            sm={{
                flexDirection: isModal ? 'row' : 'column',
                alignItems: 'center',
            }}
            md={{
                flexDirection: mdStepItemDirection,
            }}
            mr={4}
        >
            {children}
        </ResponsiveFlexBox>
    );
}
